import React from 'react'

import { css } from '@emotion/react'

import { NAVIGATION_ICONS } from '@/constants/navigationAssets'

import CommonButton from '@/components/form/Button/CommonButton'

import { mediaUp } from '@/styles/media'

import BtnGlobalCustomStyles from '@/components/form/Button/button.customStyles'

import { MobileSearchBoxWrapper } from './Options.styled'
import MobileOptionsWrapper from './MobileOptionsWrapper'

interface MobileSearchProps {
  onOpenModal: () => void
  market: string
  translatedSearchBtn: string
  settedValue: string
  submitButtonRef: React.RefObject<HTMLButtonElement>
  settedStartDate: string
  settedEndDate: string
}

const MobileSearch: React.FC<MobileSearchProps> = ({
  onOpenModal,
  translatedSearchBtn,
  settedValue,
  submitButtonRef,
  settedStartDate,
  settedEndDate
}) => {
  return (
    <MobileSearchBoxWrapper data-test-id="mobile-search-box-wrapper">
      <MobileOptionsWrapper
        onOpenModal={onOpenModal}
        settedValue={settedValue}
        settedStartDate={settedStartDate}
        settedEndDate={settedEndDate}
      />
      <CommonButton
        variant="searchWrapper"
        type="submit"
        data-test-id="search-button-wrapper"
        ref={submitButtonRef}
        customStyle={[BtnGlobalCustomStyles.searchWrapper, customStyle]}
      >
        <img src={NAVIGATION_ICONS.search} alt="Search" loading="lazy" />
        <span>{translatedSearchBtn}</span>
      </CommonButton>
    </MobileSearchBoxWrapper>
  )
}

export default MobileSearch

const customStyle = css`
  padding: 8px 16px;
  margin: 12px auto;
  width: 100%;

  ${mediaUp('md')} {
    margin: unset;
    width: unset;
  }

  img {
    max-height: 12px;
  }
`
